module.exports = __webpack_public_path__ + "static/media/brands.8ac7320b.jpg";